/* eslint-disable import/prefer-default-export */
import { applyMiddleware, createStore } from "redux";
import reduxThunk from "redux-thunk";
import { createHashHistory } from "history";
import { routerMiddleware } from "connected-react-router";

import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "src/reducers";

export const history = createHashHistory();

export const store = createStore(
  rootReducer(history),
  composeWithDevTools(applyMiddleware(reduxThunk, routerMiddleware(history)))
);
